import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@app/model/store'
import {
  BUTTON_OPENER_CONST,
  buttonOpenerFinishScenario,
  buttonOpenerInit,
  buttonOpenerPlayScenario,
  buttonOpenerSetAnimationIndex,
  buttonOpenerSetRestVisited,
} from '@widgets/Common/GigAssist/model/slice'

const { MAX_PLAYED_COUNT, ALT_TEXT, ANIMATION_STEP_DURATION, DELAY_BEFORE_ANIMATION } = BUTTON_OPENER_CONST

export const useChatButtonLogic = () => {
  const dispatch = useAppDispatch()
  const { restVisited, playedCount } = useAppSelector((state) => state.gigAssist.buttonOpener)

  useEffect(() => {
    dispatch(buttonOpenerInit())
  }, [])

  useEffect(() => {
    if (restVisited || playedCount >= MAX_PLAYED_COUNT) return

    const idleTimer = setTimeout(() => {
      dispatch(buttonOpenerSetRestVisited(localStorage.getItem('visitedProductForChatButton') === 'true'))
      dispatch(buttonOpenerPlayScenario())

      const altTextsCount = ALT_TEXT.length
      let idx = 0

      const interval = setInterval(() => {
        idx++
        if (idx < altTextsCount) {
          dispatch(buttonOpenerSetAnimationIndex(idx))
        } else {
          clearInterval(interval)
          dispatch(buttonOpenerFinishScenario())
        }
      }, ANIMATION_STEP_DURATION)
    }, DELAY_BEFORE_ANIMATION)

    return () => clearTimeout(idleTimer)
  }, [restVisited, playedCount, dispatch])
}
